import { HttpData, HttpNoData } from "../../../Core";

export async function getBitrixTasks(search, jwt) {
    const q = search ? `?search=${encodeURIComponent(search)}` : "";
    const response = await HttpNoData(`/api/v1/bitrix/tasks${q}`, 'GET', jwt);
    return response.statusSuccessful ? (response.data || []) : null;
}

export async function attachCheckToBitrixTask(taskId, content, jwt) {
    const response = await HttpData(`/api/v1/bitrix/tasks/${taskId}/check`, 'POST', jwt, { content });
    return response.statusSuccessful;
}
